class ContactModel {
  constructor(
    id,
    name,
    phone,
    email = null,
    avatar = null,
    isSelected = false,
    tags = []
  ) {
    this.id = id;
    this.name = name;
    this.phone = phone;
    this.email = email;
    this.avatar = avatar;
    this.isSelected = isSelected;
    this.tags = tags;
  }

  static fromObject(obj) {
    return new ContactModel(
      obj.id,
      obj.name,
      obj.phone,
      obj.email,
      obj.avatar,
      obj.isSelected,
      obj.tags || []
    );
  }

  toObject() {
    return {
      id: this.id,
      name: this.name,
      phone: this.phone,
      email: this.email,
      avatar: this.avatar,
      isSelected: this.isSelected,
      tags: this.tags,
    };
  }
}

export default ContactModel;
